import { render, staticRenderFns } from "./ManagePlans.vue?vue&type=template&id=455bfe45&"
import script from "./ManagePlans.vue?vue&type=script&lang=js&"
export * from "./ManagePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports